import axios from 'axios'
import { Currency } from 'src/core/models'

export async function getCurrencyListAPI(): Promise<Currency[]> {
  const { data } = await axios.get(`/api/v1/currency_tokens/?page_size=9999`)
  return data?.results
}
